<style src="./ReportNotify.scss" lang="scss"></style>
<template>
  <div class="wrapper wrapper-content">
    <div class="mail-box-header">
      <form class="form-horizontal" @submit.prevent="searchWithFilter">
        <div class="row">
          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-12">Veículo</label>
              <div class="col-sm-12">
                <input
                  type="text"
                  placeholder="ABC-1234"
                  class="form-control"
                  v-model="form.licencePlate"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data Inicial</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="startDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Inicial</label>
              <div class="col-sm-12">
                <input
                  type="time"
                  placeholder="09:00:00"
                  class="form-control"
                  v-model="startTime"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Data final</label>
              <div class="col-sm-12">
                <input
                  type="date"
                  placeholder="30/12/2019"
                  class="form-control"
                  v-model="endDate"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-2">
            <div class="form-group">
              <label class="col-sm-12">Hora Final</label>
              <div class="col-sm-12">
                <input
                  type="time"
                  placeholder="15:00:00"
                  class="form-control"
                  v-model="endTime"
                />
              </div>
            </div>
          </div>

          <div class="col-sm-3">
            <div class="form-group">
              <label class="col-sm-12">Status</label>

              <div class="col-sm-6">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="form.showOpened" />
                    Aberto
                  </label>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="checkbox">
                  <label>
                    <input type="checkbox" v-model="form.showClosed" />
                    Fechado
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-2">
            <button class="btn btn-lg btn-primary" type="submit">
              <i class="fa fa-search"></i>
              Buscar
            </button>
          </div>

          <div class="col-sm-2">
            <button
              class="btn btn-lg btn-primary"
              type="button"
              @click="exportCsv"
            >
              <i class="fa fa-search"></i>
              Exportar CSV
            </button>
          </div>
        </div>
      </form>
    </div>

    <spinner v-if="showSpinner" />

    <div class="mail-box">
      <table class="table table-hover table-mail">
        <thead>
          <tr>
            <th>Placa</th>
            <th>Estacionamento</th>
            <th>Código</th>
            <th>Data</th>
            <th>Hora</th>
            <th>Data(pagamento)</th>
            <th>Hora(pagamento)</th>
            <th>Colaborador</th>
          </tr>
        </thead>
        <tbody>
          <tr class="read" v-for="(item, idx) in resultList" :key="idx">
            <td>{{ formatLicencePlate(item.licencePlate) }}</td>
            <td>{{ item.park }}</td>
            <td>{{ item.creditCode }}</td>
            <td>{{ fillDate(item.createdAt) }}</td>
            <td>{{ fillTime(item.createdAt) }}</td>
            <td>{{ fillDate(item.paymentDate) }}</td>
            <td>{{ fillTime(item.paymentDate) }}</td>
            <td>{{ item.employee }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-group paginatecontent" v-if="countPages > 0">
      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageLeft"
        @click="previousPage"
      >
        <i class="fa fa-arrow-left" />
      </button>

      <button
        class="btn btn-light btn-sm paginatebutton"
        :disabled="hasPageRight"
        @click="nextPage"
      >
        <i class="fa fa-arrow-right" />
      </button>
    </div>
  </div>
</template>

<script>
import Spinner from '@/components/Spinner';

export default {
  components: { Spinner },
  data() {
    return {
      showSpinner: false,
      form: {
        employee: 'everybody',
        licencePlate: '',
        pageSkip: 0,
        pageLimit: 30,
        showOpened: true,
        showClosed: false,
      },
      startDate: '',
      endDate: '',
      startTime: '',
      endTime: '',
      countPages: 0,
      employeeList: [],
      resultList: [],
    };
  },
  computed: {
    hasPageLeft() {
      return this.form.pageSkip === 0;
    },
    hasPageRight() {
      return this.form.pageSkip + this.form.pageLimit >= this.countPages;
    },
  },
  mounted() {},
  methods: {
    fillDate(value) {
      if (!value) {
        return '-';
      }
      return new Date(value).toLocaleDateString('pt-BR');
    },
    fillTime(value) {
      if (!value) {
        return '-';
      }
      return new Date(value).toLocaleTimeString('pt-BR');
    },
    formatLicencePlate(licencePlate) {
      return licencePlate.toUpperCase();
    },
    async listEmployee() {
      const employeeListFull = await this.$store.dispatch(
        'EMPLOYEE/GetEmployeeList',
      );
      const employeeList = employeeListFull.map(item => ({
        id: item._id,
        fullName: item.fullName,
      }));
      this.employeeList = employeeList;
    },
    searchWithFilter() {
      this.pageSkip = 0;
      this.filterReport();
    },
    async exportCsv() {
      this.showSpinner = true;
      const query = {
        ...this.form,
      };

      if (this.startDate) {
        if (!this.startTime) {
          this.startTime = '00:00';
        }
        query.startDate = `${this.startDate} ${this.startTime}:00`;
      }

      if (this.endDate) {
        if (!this.endTime) {
          this.endTime = '00:00';
        }
        query.endDate = new Date(`${this.endDate} ${this.endTime}:00`);
      }

      try {
        const response = await this.$store.dispatch(
          'REPORTS/DownloadReportCsv',
          {
            query,
          },
        );

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'RELATORIO DE NOTIFICACOES.csv');
        document.body.appendChild(link);
        link.click();
      } catch (errors) {
        this.resultList = [];
      } finally {
        this.showSpinner = false;
      }
    },
    async filterReport() {
      this.showSpinner = true;
      const query = {
        ...this.form,
      };

      if (this.startDate) {
        if (!this.startTime) {
          this.startTime = '00:00';
        }
        query.startDate = `${this.startDate} ${this.startTime}:00`;
      }

      if (this.endDate) {
        if (!this.endTime) {
          this.endTime = '00:00';
        }
        query.endDate = new Date(`${this.endDate} ${this.endTime}:00`);
      }

      try {
        const reports = await this.$store.dispatch('REPORTS/ReportNotify', {
          query,
        });

        if (!reports.list) {
          this.resultList = [];
          return true;
        }

        this.countPages = reports.count;

        const resultList = reports.list.map(item => ({
          licencePlate: item.vehicle.licencePlate,
          creditCode: item.creditCode,
          paymentDate: item.paymentDate,
          createdAt: item.createdAt,
          totalMinutes: item.totalTime,
          employee: item.employee ? item.employee.fullName : '-',
          park: item.parks ? item.parks.parkName : '-',
        }));

        this.resultList = resultList;
        this.showSpinner = false;
      } catch (errors) {
        this.resultList = [];
        this.showSpinner = false;
      }
    },
    nextPage() {
      if (this.form.pageSkip + this.form.pageLimit > this.countPages) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip + this.form.pageLimit;

      this.filterReport();
    },
    previousPage() {
      if (this.form.pageSkip === 0) {
        return;
      }
      this.form.pageSkip = this.form.pageSkip - this.form.pageLimit;

      this.filterReport();
    },
  },
};
</script>